module.exports = __webpack_public_path__ + "static/img/RU03.6e12306.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/RU03.jpg
// module id = 2Z/3
// module chunks = 1